<template>
    <div>
        <el-dialog
        :visible.sync="viewDetails"
        :close-on-click-modal="true"
        width="95%"
        top="0"
        custom-class="customClass step-details"
        :lock-scroll="true"
        :before-close="closeModal"
    >
        <el-row :gutter="20" class="mb-4">
            <el-col :span="24">
                <el-card>
                    <div class="text-left">
                        <el-button size="small" class="submit-btn" icon="el-icon-back" @click="closeModal">Back</el-button>
                    </div>
                    <slot></slot>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-4">
            <el-col :span="24">
                <el-card>
                    <div class="text-center mb-2">
                        <h4>Performance - By Steps</h4>
                    </div>
                    <div class="text-right mb-2">
                        <el-input v-model="searched_name" size="mini" placeholder="Search by steps" style="max-width: 300px" >
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <el-button class="btn submit-btn" icon="el-icon-download" size="mini" style="margin-left: 10px;" :style="!filtered_list.length ? 'opacity: 0.6; cursor: not-allowed;' : ''" @click="downloadStepPerformanceResults">Download Reports</el-button>
                    </div>
                    <table class="task-table">
                        <thead>
                            <tr>
                                <th>STEPS</th>
                                <th>
                                    CATEGORY
                                    &nbsp;
                                    <el-popover placement="bottom" trigger="click">
                                        <div>
                                            <el-checkbox-group v-model="selected_category_list">
                                                <el-checkbox
                                                    v-for="(
                                                        status, status_index
                                                    ) in category_list"
                                                    :key="status_index"
                                                    class="mb-2 checkbox-lable"
                                                    :label="status"
                                                    :value="status"
                                                    style="display: block"
                                                    @change="changeFilterTaskStatus()"
                                                ></el-checkbox>
                                            </el-checkbox-group>

                                            <div class="flex justify-between mt-4">
                                                <span
                                                    class="text-xs cursor-pointer primary-theme-color"
                                                    @click="selectAllTaskStatus()"
                                                    >Select all</span
                                                >
                                                <span
                                                    class="text-xs cursor-pointer"
                                                    @click="resetSelectedTaskStatus()"
                                                    >Reset</span
                                                >
                                            </div>
                                        </div>

                                        <!-- <i class="el-icon-caret-bottom" slot="reference" style="font-size: 12px;"></i> -->
                                        <span slot="reference" class="cursor-pointer">
                                            <img
                                                src="../../../../../../../src/assets/images/filter-icon.png"
                                                width="9"
                                                alt=""
                                            />
                                        </span>
                                    </el-popover>
                                </th>
                                <th>
                                    YES
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_yes == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_yes = 'asc';
                                            sort_by_no = '';
                                            sort_by_na = '';
                                            sort_by_none = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_yes == '' || sort_by_yes == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_yes = 'desc';
                                            sort_by_no = '';
                                            sort_by_na = '';
                                            sort_by_none = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th>
                                    NO
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_no == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_no = 'asc';
                                            sort_by_yes = '';
                                            sort_by_na = '';
                                            sort_by_none = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_no == '' || sort_by_no == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_no = 'desc';
                                            sort_by_yes = '';
                                            sort_by_na = '';
                                            sort_by_none = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                                <th>
                                    NOT APPLICABLE
                                    <span slot="reference" class="cursor-pointer">
                                        <i
                                            v-if="sort_by_na == 'desc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-top"
                                            @click="
                                            sort_by_na = 'asc';
                                            sort_by_yes = '';
                                            sort_by_no = '';
                                            sort_by_none = '';
                                            "
                                        ></i>
                                        <i
                                            v-if="sort_by_na == '' || sort_by_na == 'asc'"
                                            style="font-size: 12px"
                                            class="el-icon-caret-bottom"
                                            @click="
                                            sort_by_na = 'desc';
                                            sort_by_yes = '';
                                            sort_by_no = '';
                                            sort_by_none = '';
                                            "
                                        ></i>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <div style="height: 400px; overflow-y: scroll;">
                                <template v-for="(item, index) in filtered_list">
                                    <tr v-if="index >= startNumber - 1 && index < endNumber" :key="'steps-item-count-'+index">
                                        <td>
                                            <!-- TODO; Location popup -->
                                            <div
                                                class="mb-2 title underline cursor-pointer"
                                                @click="getStepsOfLocations(item.name, item.intermediate_category_id)"
                                                v-html="item.name ? item.name : '-'"
                                            ></div>
                                        </td>
                                        <td>
                                            <div class="mb-2">{{ item.category_name ? item.category_name : '-' }}</div>
                                            <div v-if="item.intermediate_category_name">({{ item.intermediate_category_name }})</div>
                                        </td>
                                        <td>{{ item.yes_percentage + '%' }}</td>
                                        <td>{{ item.no_percentage + '%' }}</td>
                                        <td>{{ item.na_percentage + '%' }}</td>
                                    </tr>
                                </template>
                            </div>
                        </tbody>
                    </table>
                    <el-row :gutter="20" class="mt-4">
                        <el-col :span="8" class="text-left">
                            <div><b>Showing</b> {{ startNumber }} to {{ endNumber }} of {{ filtered_list.length }} results</div>
                        </el-col>
                        <el-col :span="8" class="text-center">
                            <el-select v-model="perPage" name="per_page" placeholder="select per page" style="width: 90px !important;">
                                <el-option label="10" :value="10"></el-option>
                                <el-option label="25" :value="25"></el-option>
                                <el-option label="50" :value="50"></el-option>
                                <el-option label="100" :value="100"></el-option>
                            </el-select>
                            &nbsp;per page
                        </el-col>
                        <el-col :span="8" class="text-right">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="filtered_list.length"
                                :page-size="perPage"
                                :current-page.sync="currentPage"
                            ></el-pagination>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </el-dialog>

    <!-- Steps of location popup -->
        <el-dialog :visible.sync="step_location_detail_show" :close-on-click-modal="true" width="95%" top="0"
            custom-class="customClass" :lock-scroll="true" :show-close="true">
            <div class="tab">
                <el-card class="box-card">
                    <div style="padding: 0 20px 0 20px" class="text-left">
                        <el-button icon="el-icon-back" class="submit-btn" size="mini"
                            @click="step_location_detail_show = false">
                            Back
                        </el-button>
                    </div>

                    <div v-loading="is_step_location_detail_loading" style="padding: 30px 20px;">
                        <div class="my-2">
                            <!-- CSV -->
                            <div class="text-right px-2">
                                <el-button class="submit-btn" icon="el-icon-download" size="small" @click="downloadStepOfLocationDetails">Download Reports</el-button>
                            </div>
                            <!-- ./CSV -->
                        </div>
                        <div class="text-center mb-5">
                            <h4>{{header_step_name}}</h4>
                        </div>
                        <table class="task-table mt-2">
                            <thead>
                                <tr>
                                    <!-- <th>EMP ID</th> -->
                                    <th>Location Name</th>
                                    <th>CATEGORY</th>
                                    <th>YES</th>
                                    <th>NO</th>
                                    <th>NOT APPLICABLE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="step_location_details_data.length > 0">
                                    <tr v-for="(item, index) in  step_location_details_data" :key="'step-location-data-'+index">
                                        <!-- <td>{{ item.emp_id }}</td> -->
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.category_name }}</td>
                                        <td>{{ item.yes_percentage + '%' }}</td>
                                        <td>{{ item.no_percentage + '%' }}</td>
                                        <td>{{ item.na_percentage + '%' }}</td>
                                    </tr>
                                </template>
                                <tr v-else>
                                    <td colspan="7">NO DATA AVAILABLE</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-card>
            </div>
        </el-dialog>
      <!-- Steps of location popup -->
    </div>
</template>

<script>
import exportFromJSON from 'export-from-json';
import labourPlanningService from "../../../../../../services/labourPalnningService";
export default {
    name: 'StepPerformanceDetails',
    props: {
        viewDetails: {
            type: Boolean,
            default: false
        },
        height: {
            type: Number,
            default: 400
        },
        performanceResults: {
            type: Array,
            default: () => []
        },
        outlet: {
            type: String,
            default: null
        },
        fromDate: {
            type: String,
            default: null
        },
        toDate: {
            type: String,
            default: null
        },
        intermediateCategory: {
            type: String,
            default: null
        },
        dashboardTab: {
            type: String,
            default: 'audit'
        }
    },
    data() {
        return {
            searched_name: "",
            selected_category_list: [],
            currentPage: 1,
            perPage: 10,
            sort_by_yes: "",
            sort_by_no: "",
            sort_by_na: "",
            sort_by_none: "",
            step_location_detail_show: false,
            is_step_location_detail_loading: false,
            step_location_details: [],
            header_step_name: ''
        };
    },
    computed: {
        step_location_details_data() {
            let originalData = this.step_location_details;
            let data = originalData.length ? JSON.parse(JSON.stringify(originalData)) : [];

            return data;
        },
        category_list() {
            let copy_arr = [...this.performanceResults];
            let result = [];

            for(let i = 0; i < copy_arr.length; i++) {
                let check = result.find(el => el == copy_arr[i].category_name);
                if(check === undefined) {
                    result.push(copy_arr[i].category_name);
                }
            }

            return result;
        },
        filtered_list() {
            let results = this.performanceResults;

            if(this.searched_name) {
                results = results.filter(el => el.name.toString().toLowerCase().startsWith(this.searched_name.toString().toLowerCase()))
            }

            if(this.selected_category_list.length) {
                results = results.filter(el => this.selected_category_list.includes(el.category_name));
            }

            if(this.sort_by_yes) {
				if(this.sort_by_yes.toString().toLowerCase() == 'asc') {
					results.sort((a, b) => a.yes_percentage - b.yes_percentage);
				}

				if(this.sort_by_yes.toString().toLowerCase() == 'desc') {
					results.sort((a, b) => b.yes_percentage - a.yes_percentage);
				}
			}

            if(this.sort_by_no) {
				if(this.sort_by_no.toString().toLowerCase() == 'asc') {
					results.sort((a, b) => a.no_percentage - b.no_percentage);
				}

				if(this.sort_by_no.toString().toLowerCase() == 'desc') {
					results.sort((a, b) => b.no_percentage - a.no_percentage);
				}
			}

            if(this.sort_by_na) {
				if(this.sort_by_na.toString().toLowerCase() == 'asc') {
					results.sort((a, b) => a.na_percentage - b.na_percentage);
				}

				if(this.sort_by_na.toString().toLowerCase() == 'desc') {
					results.sort((a, b) => b.na_percentage - a.na_percentage);
				}
			}

            if(this.sort_by_none) {
				if(this.sort_by_none.toString().toLowerCase() == 'asc') {
					results.sort((a, b) => a.none_percentage - b.none_percentage);
				}

				if(this.sort_by_none.toString().toLowerCase() == 'desc') {
					results.sort((a, b) => b.none_percentage - a.none_percentage);
				}
			}

            return results;
        },
        currentIndex() {
            let index = 0;

            let total_records = this.filtered_list.length;

            let total_pages = (total_records / this.perPage);
            if(total_pages) {
                total_pages = total_pages.toFixed();
            }

            if(this.currentPage > 1) {
                index = this.currentPage - 1;
            }

            return index;
        },
        startNumber() {
            let start = (this.currentPage * this.perPage) - (this.perPage - 1);
            return start;
        },
        endNumber() {
            let end = Math.min(this.startNumber + this.perPage - 1, this.filtered_list.length);
            return end;
        },
    },
    methods: {
        resetSelectedTaskStatus() {
            this.selected_category_list = [];
        },
        selectAllTaskStatus() {
            this.selected_category_list = [...this.category_list];
        },
        changeFilterTaskStatus() {
            console.log('changeFilterTaskStatus');
        },
        closeModal() {
            this.$emit('closeStepsInsightsDetailsModal', true);
        },
        downloadStepPerformanceResults() {
            let data = this.performanceResults.map(el => ({
                "Steps": el.name,
                "Category": el.category_name,
                "Yes": el.yes_percentage + '%',
                "No": el.no_percentage + '%',
                "Not Applicable": el.na_percentage + '%',
                "None": el.none_percentage + '%',
            }));
            const fileName = 'Step_Performance_Results';
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        downloadStepOfLocationDetails() {
            let data = this.step_location_details_data.map(el => ({
                "Name": el.name,
                "Category": el.category_name,
                "Yes": el.yes_percentage + '%',
                "No": el.no_percentage + '%',
                "Not Applicable": el.na_percentage + '%',
                "None": el.none_percentage + '%',
            }));
            const fileName = 'Steps_Of_Location_Details';
            const exportType = exportFromJSON.types.csv;
            exportFromJSON({ data, fileName, exportType });
        },
        getStepsOfLocations(name, intermediate_category_id) {
            this.is_step_location_detail_loading = true;
            this.header_step_name = name;
            // Validate if data is already exist

            let params = {
                start_date: this.fromDate,
                end_date: this.toDate,
                location_wise: true,
                filters: {
                    outlets: [],
                    subtasks: []
                },
                main_category: this.dashboardTab,
                intermediate_category: intermediate_category_id,
                sort_by: "no_percentage",
                name: name,
                basics: "outlet"
            };
            labourPlanningService.getStepLocations(params)
            .then(response => {
                // console.log(response.data);
                // After API response open modal
                this.step_location_detail_show = true;
                this.is_step_location_detail_loading = false;
                this.step_location_details = JSON.parse(response.data);
                this.step_location_details = this.step_location_details.results
            }).catch(error => {
                this.step_location_detail_show = false;
                this.is_step_location_detail_loading = false;
                console.error(error.response.data);
            });
        }
    }
}
</script>

<style lang="scss">
    .customClass.step-details {
        background: #fff;
    }
</style>
